import styled from 'styled-components';

export const FilterLabel = styled.div`
    width: 11rem;
    text-align: left;
    line-height: 1.1em;

    &.active {
        font-weight: bold;
    }

    small {
        display: block;
        font-size: ${(props) => props.theme.FontSizeSm};
        line-height: 1em;
        padding-top: 0.25rem;
    }
`;

export const FilterWrapper = styled.div`
    flex: 1 0 0;
    padding: 0 2rem 0 1rem;
`;

/**
 * Riga di un filtro avanzato: label a sinistra, controllo a destra.
 * Sotto NarrowScreenMaxWidth passa a colonna singola (label sopra, controllo a tutta larghezza)
 * e normalizza i controlli antd che altrimenti sfondano il contenitore.
 */
export const FilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;

    .ant-form-item {
        margin-bottom: 1rem;
    }

    margin-bottom: 1rem;

    @media (max-width: ${(props) => props.theme.NarrowScreenMaxWidth}) {
        flex-direction: column;
        align-items: stretch;

        ${FilterLabel} {
            width: 100%;
            margin-bottom: 0.5rem;
        }

        ${FilterWrapper} {
            width: 100%;
            padding: 0;
        }

        /* I radio button si distribuiscono sulla riga e vanno a capo quando non ci stanno.
           antd toglie il bordo sinistro ai bottoni successivi al primo e usa ::before come
           separatore: andando a capo quel bordo serve, quindi lo ripristiniamo. */
        .ant-radio-group {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }

        .ant-radio-button-wrapper {
            flex: 1 1 auto;
            text-align: center;
            border-left-width: 1px;

            &::before {
                display: none;
            }
        }

        .ant-segmented {
            width: 100%;
        }

        .ant-segmented-item {
            flex: 1 1 0;
        }

        /* CustomSelect ha un min-width di 200px che a schermi stretti sfonda la riga */
        .ant-select {
            width: 100%;
            min-width: 0;
        }
    }
`;
